module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('DO_YOU_WANT_TO_BUY_PACKAGE')) + "\n        "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('buy')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('BUY')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f4a636","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/buy-package.vue
// module id = 1218
// module chunks = 0